'use strict';

var _ = require('lodash');
var AdvancedHepCommonValidationService = function AdvancedHepCommonValidationService(advancedHepPayloadService, AdvancedHepGridConstants) {
  function isOverlapping(range1, range2, ranges, notEqual) {
    var from1 = range1[ranges[0]];
    var to1 = range1[ranges[1]];
    var from2 = range2[ranges[0]];
    var to2 = range2[ranges[1]];
    var additionalCheck = notEqual === true ? !(from1 === from2 && to1 === to2) : true;
    return additionalCheck && to1 >= from2 && from1 <= to2;
  }
  function isCustomHepType(type) {
    return _.includes(AdvancedHepGridConstants.CUSTOM_VALIDATION_TYPES, type);
  }
  function isRangesAreOverlapping(entries, ranges, notEqual) {
    for (var i = 0; i < entries.length; i++) {
      for (var j = i + 1; j < entries.length; j++) {
        if (isOverlapping(entries[i], entries[j], ranges, notEqual)) {
          return true;
        }
      }
    }
    return false;
  }
  function isRangesAreOverlappingForAP(entries, ranges, notEqual) {
    for (var i = 0; i < entries.length; i++) {
      for (var j = i + 1; j < entries.length; j++) {
        if (isOverlapping(entries[i], entries[j], ranges, notEqual) && hasDuplicationsInCommaSeparatedValues(entries[i], entries[j], 'fareTypeIndicator')) {
          return true;
        }
      }
    }
    return false;
  }
  function getRangeTypes(type) {
    switch (type) {
      case 'FOMinStayGrouping':
        return AdvancedHepGridConstants.MIN_STAY_RANGES;
      case 'FOMaxStayGrouping':
        return AdvancedHepGridConstants.MAX_STAY_RANGES;
      case 'FOAdvancePurchaseGrouping':
        return AdvancedHepGridConstants.ADV_PURCHASE_RANGES;
      default:
        return AdvancedHepGridConstants.DEFAULT_RANGES;
    }
  }
  function constructKey(row, propertiesList) {
    return _.chain(row).pick(propertiesList).values().value().join('.');
  }
  function getKeyValues(type, entry, attributes) {
    if (type === 'FOMarketList') {
      return _.pick(entry, ['hostCarrier', 'originAirport', 'destinationAirport', 'foCabin', 'marketListCategory', 'benchmarkCarrier', 'hostFareTypeIndicator', 'benchmarkFareTypeIndicator', 'fareSource']);
    }
    if (type === 'FOTacticalFBCPatternConfig') {
      return _.pick(entry, ['hostCarrier', 'origin', 'destination', 'originCountry', 'destinationCountry', 'foCabin', 'propertyName', 'propValue']);
    }
    if (type === 'FP_MetroMarket') {
      return _.pick(entry, ['marketOrigin', 'marketDestination']);
    }
    if (type === 'FOFareBrandDefinitionConfig') {
      return _.pick(entry, ['carrier']);
    }

    // if (type === 'FOTacticalUserOverrides') {
    //     return [];
    // }

    if (_.isEmpty(entry.hostCarrier) || _.isNil(entry.hostCarrier)) {
      entry['hostCarrier'] = '';
    }
    return _.pick(entry, _.includes(attributes, 'legId') ? _.concat(advancedHepPayloadService.getLegIdAttributes(), attributes) : attributes);
  }
  function isDuplicate(newEntry, allRows, attributes, type) {
    var fieldsToCheck = getKeyValuesWithoutPossiblyOverlappingFields(type, newEntry, attributes);
    var allKeyValues = getKeyValues(type, newEntry, attributes);
    var rangesInKey = hasAnyRangesInKey(allKeyValues);
    var commaSeparatedFieldsInKey = hasAnyCommaSeparatedFieldsInKey(allKeyValues);
    fieldsToCheck.duplicatedRanges = rangesInKey;
    fieldsToCheck.overlappingCommaSeparatedFields = commaSeparatedFieldsInKey;
    var rowsIdenticalToModified = _.chain(allRows).transform(function (result, entry) {
      var keyValues = getKeyValuesWithoutPossiblyOverlappingFields(type, entry, attributes);
      keyValues.duplicatedRanges = rangesInKey ? hasDuplicatedRanges(newEntry, entry) : false;
      keyValues.overlappingCommaSeparatedFields = commaSeparatedFieldsInKey ? hasOverlappingCommaSeparatedFields(newEntry, entry) : false;
      return result.push(keyValues);
    }).filter(fieldsToCheck).value();
    if (isCustomHepType(type) && rowsIdenticalToModified.length > 1) {
      if (Object.keys(rowsIdenticalToModified[0]).length !== Object.keys(rowsIdenticalToModified[1]).length) {
        return false;
      }
    }
    return rowsIdenticalToModified.length > 1;
  }
  function hasOverlappingCommaSeparatedFields(newEntry, entry) {
    return !!_.find(AdvancedHepGridConstants.COMMA_SEPARATED_FIELDS, function (field) {
      return newEntry[field] && hasDuplicationsInCommaSeparatedValues(newEntry, entry, field);
    });
  }
  function hasDuplicationsInCommaSeparatedValues(newEntry, entry, field) {
    var newEntryValues = _.split(newEntry[field], ',');
    var existingEntryValues = _.split(entry[field], ',');
    return _.intersection(newEntryValues, existingEntryValues).length > 0;
  }
  function hasAnyRangesInKey(fieldsToCheck) {
    var rangeFields = AdvancedHepGridConstants.KEY_DATE_RANGES.concat(AdvancedHepGridConstants.KEY_RANGES);
    for (var rangeField in rangeFields) {
      if (fieldsToCheck[rangeFields[rangeField][0]] || rangeFields[rangeField][1]) {
        return true;
      }
    }
    return false;
  }
  function hasAnyCommaSeparatedFieldsInKey(fieldsToCheck) {
    return !!_.find(AdvancedHepGridConstants.COMMA_SEPARATED_FIELDS, function (field) {
      return fieldsToCheck[field];
    });
  }
  function getKeyValuesWithoutPossiblyOverlappingFields(type, entry, attributes) {
    var fieldsToCheck = getKeyValues(type, entry, attributes);
    var commaSeparatedFields = AdvancedHepGridConstants.COMMA_SEPARATED_FIELDS;
    _.forEach(commaSeparatedFields, function (commaSeparatedField) {
      _.unset(fieldsToCheck, commaSeparatedField);
    });
    if (AdvancedHepGridConstants.KEY_OVERLAPPING_ALLOWED_TYPES.indexOf(type) == -1) {
      var rangeFields = AdvancedHepGridConstants.KEY_DATE_RANGES.concat(AdvancedHepGridConstants.KEY_RANGES);
      _.forEach(rangeFields, function (rangeField) {
        _.unset(fieldsToCheck, rangeField[0]);
        _.unset(fieldsToCheck, rangeField[1]);
      });
    }
    return fieldsToCheck;
  }
  function noDuplicationsInDateRange(newEntry, entry, rangeFieldNames) {
    var dateRangeStart1 = newEntry[rangeFieldNames[0]];
    var dateRangeEnd1 = newEntry[rangeFieldNames[1]];
    var dateRangeStart2 = entry[rangeFieldNames[0]];
    var dateRangeEnd2 = entry[rangeFieldNames[1]];
    return !(dateRangeEnd1.value.toDate() >= dateRangeStart2.value.toDate() && dateRangeStart1.value.toDate() <= dateRangeEnd2.value.toDate());
  }
  function hasDuplicatedRanges(newEntry, entry) {
    var keyRanges = AdvancedHepGridConstants.KEY_RANGES;
    var dateKeyRanges = AdvancedHepGridConstants.KEY_DATE_RANGES;
    for (var keyRange in keyRanges) {
      if (newEntry[keyRanges[keyRange][0]] && noDuplicationsInRange(newEntry, entry, keyRanges[keyRange])) {
        return false;
      }
    }
    for (var dateKeyRange in dateKeyRanges) {
      if (newEntry[dateKeyRanges[dateKeyRange][0]] && noDuplicationsInDateRange(newEntry, entry, dateKeyRanges[dateKeyRange])) {
        return false;
      }
    }
    return true;
  }
  function noDuplicationsInRange(newEntry, entry, rangeFieldNames) {
    var rangeStart1 = parseFloat(newEntry[rangeFieldNames[0]]);
    var rangeEnd1 = parseFloat(newEntry[rangeFieldNames[1]]);
    var rangeStart2 = parseFloat(entry[rangeFieldNames[0]]);
    var rangeEnd2 = parseFloat(entry[rangeFieldNames[1]]);
    return !(rangeEnd1 >= rangeStart2 && rangeStart1 <= rangeEnd2);
  }
  return {
    isDuplicate: isDuplicate,
    constructKey: constructKey,
    getRangeTypes: getRangeTypes,
    isRangesAreOverlappingForAP: isRangesAreOverlappingForAP,
    isRangesAreOverlapping: isRangesAreOverlapping,
    getKeyValues: getKeyValues
  };
};
AdvancedHepCommonValidationService.$inject = ['AdvancedHepPayloadService', 'AdvancedHepGridConstants'];
module.exports = AdvancedHepCommonValidationService;